import Typography from '@mui/material/Typography'

export const RequiredDot = () => {
  return (
    <Typography component="span" color="primary" variant="h3">
      *
    </Typography>
  )
}
